import React, { useEffect, useContext } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { Form } from 'react-bootstrap'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import './QiagenManagerContainer.scss'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Patient } from '../../models/RegisterPatient'
import { AuthContext } from '../../contexts'
import { QiagenManagerDefaultData, QiagenManagerFormSchema } from './helpers'
import { QiagenManagerSearch } from './components'

export const QiagenManagerContainer = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const translatn = 'qiagenManagerContainer.'
  const parentClass = 'vcr-pp-qiagen-manager-'

  const auth = useContext(AuthContext)
  const userSiteId = auth?.authenticatedUser?.siteId ?? ''
  const userSiteName = auth?.authenticatedUser?.siteName ?? ''

  let formDefaultValues = JSON.parse(JSON.stringify(QiagenManagerDefaultData))
  formDefaultValues.siteID = userSiteId
  formDefaultValues.siteName = userSiteName


  const formMethods = useForm<Patient>({
    resolver: zodResolver(QiagenManagerFormSchema),
    mode: 'all',
    defaultValues: formDefaultValues,
  })

  return (
    <Container className={`${parentClass}container`} fluid>
      <Row className={`${parentClass}header `}>
        <Col className={`${parentClass}header-left-content`}>
          <h4 className={`${parentClass}header-text `}>
            {t(`${translatn}qiagenManagerSearch`)}
          </h4>
        </Col>
      </Row>
      <Row className={`${parentClass}form`}>
        <Col lg={12} md={12} sm={12}>
          <FormProvider {...formMethods}>
            <Form noValidate>
              <QiagenManagerSearch />
            </Form>
          </FormProvider>
        </Col>        
      </Row>
    </Container>
  )
}
